import { Directive, ElementRef, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { unsubscribeAll } from '../../app.helpers';
import { BlockedUIControl, CurrentOperation, OperationInfo } from '../../long-operations/long-operations.interface';
import { OperationInfoService } from '../../long-operations/operation-info.service';
import { PointerEvents } from './operation-managed-control.directive.helpers';

export enum DATA_ATTRIBUTES {
  TEST_ID = 'data-test-id',
}

@Directive({
  selector: '[operation-managed-control]',
})
export class OperationManagedControlDirective implements OnInit, OnDestroy {
  private hostElementId = '';
  private isDisabled = false;

  private renderer = inject(Renderer2);
  private operationInfoService = inject(OperationInfoService);
  private elementRef = inject<ElementRef<HTMLButtonElement>>(ElementRef<HTMLButtonElement>);

  private subscriptions: Subscription[] = [];

  public ngOnInit(): void {
    this.hostElementId = this.elementRef.nativeElement.getAttribute(DATA_ATTRIBUTES.TEST_ID) ?? '';
    this.isDisabled = this.elementRef.nativeElement.disabled;

    this.subscriptions.push(
      this.operationInfoService.operationInProgress$
        .pipe(filter(({ operation }: CurrentOperation) => this.shouldDisableThisControl(operation)))
        .subscribe(({ status }: CurrentOperation) => {
          status
            ? this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true')
            : this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled');

          status
            ? this.elementRef.nativeElement.style.setProperty('pointer-events', PointerEvents.NONE)
            : this.elementRef.nativeElement.style.setProperty('pointer-events', PointerEvents.AUTO);
        }),
    );
  }

  public ngOnDestroy(): void {
    unsubscribeAll(this.subscriptions);
  }

  private shouldDisableThisControl(operation: OperationInfo): boolean {
    return (
      operation.blockedUIControls?.find((item: BlockedUIControl) => item.elementId === this.hostElementId) &&
      !this.isDisabled
    );
  }
}
